import {GetBag, GetBagCallback, GetBagStateOnlyCallback} from "@next/eventservice"
import State from "ducks/state"
import {Store} from "@reduxjs/toolkit"
import {ShoppingBagApiGet} from "../../api/shoppingbag"
import {setBackDataInSession} from "../../utils/gtmSdkShoppingBagCallback"
import {
    getNextVisitorCookieTimestamp,
    removeSessionStorageTimestamp,
    setSessionStorageTimestamp,
} from "../../hooks/NextVisitor/useBagFlashNotification.utils"

const getBagESB = new GetBag()
const getBagCallbackESB = new GetBagCallback()
const getBagStateOnlyCallbackESB = new GetBagStateOnlyCallback()

const skipRebuildUrls = ["delivery", "checkout", "myaccount/addresses", "redirect_navigate", "navigate"]

export const shouldSkipRebuild = (href: string, guestAccountConverted: boolean) => {
    return (
        guestAccountConverted === false &&
        skipRebuildUrls.some(matchHref => href.includes(matchHref)) &&
        !href.includes("secure/checkout/complete")
    )
}

export const LoadShoppingBagApiData = (
    url: string,
    guestAccountConverted: boolean,
    enableMinibagNotification: boolean,
) => {
    const href = window.location.href.toLowerCase()
    const skipRebuild = shouldSkipRebuild(href, guestAccountConverted)

    const ap = href.includes("/login")

    if (enableMinibagNotification) {
        // Store the NextVisitor cookie timestamp in session storage to compare against later in ShoppingBag for bag flash notification
        // Bag GET updates the NextVisitor cookie so we need to capture the "old" value here before it gets updated.
        const nextVisitorCookieTimestamp = getNextVisitorCookieTimestamp()
        if (nextVisitorCookieTimestamp) {
            setSessionStorageTimestamp(nextVisitorCookieTimestamp)
        }
    } else {
        // If the bag flash notification feature is disabled, ensure we clear any existing session storage timestamp
        removeSessionStorageTimestamp()
    }

    ShoppingBagApiGet({skipRebuild, ap}, `${url}/bag/get`, getBagCallbackESB, setBackDataInSession)
}

export const SubscribeToShoppingBagGet = (siteUrl: string, store: Store, enableMinibagNotification: boolean) => {
    getBagESB.subscribe(data => {
        if (!data.getBagStateOnly) {
            LoadShoppingBagApiData(siteUrl, data.guestAccountConverted, enableMinibagNotification)
        } else {
            const state = store.getState() as State

            if (state.shoppingBag.loading) return

            getBagStateOnlyCallbackESB.publish({
                eventId: data.eventId,
                status: 200,
                textStatus: "success",
                success: true,
                data: state.shoppingBag,
            })
        }
    })
}
